import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserData } from "../../redux/authSlice";
import APIs from "../../APIs"; // Adjust path if needed

const LoginModal = () => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const [formData, setFormData] = useState({
  //   email: "",
  //   password: "",
  // });
  // const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(false);
  // const [message, setMessage] = useState("");
  // const [toastData, setToastData] = useState(null);

  // // ✅ Load saved email/password from sessionStorage on mount
  // useEffect(() => {
  //   const savedData = sessionStorage.getItem("loginFormData");
  //   if (savedData) {
  //     setFormData(JSON.parse(savedData));
  //   }
  // }, []);

  // // ✅ Save formData whenever it changes
  // useEffect(() => {
  //   sessionStorage.setItem("loginFormData", JSON.stringify(formData));
  // }, [formData]);

  // // Open modal on mount
  // useEffect(() => {
  //   const modalEl = document.getElementById("LoginModalToggle");
  //   if (!modalEl) return;

  //   const modal = new window.bootstrap.Modal(modalEl);
  //   modal.show();

  //   const handleHidden = () => navigate(-1);
  //   modalEl.addEventListener("hidden.bs.modal", handleHidden);

  //   return () => {
  //     modalEl.removeEventListener("hidden.bs.modal", handleHidden);
  //   };
  // }, [navigate]);

  // // Handle input change
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // // Validate form
  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.email) {
  //     newErrors.email = "Email is required";
  //   } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
  //     newErrors.email = "Enter a valid email";
  //   }

  //   if (!formData.password) {
  //     newErrors.password = "Password is required";
  //   } else if (formData.password.length < 6) {
  //     newErrors.password = "Password must be at least 6 characters";
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // // Submit form
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;

  //   setLoading(true);
  //   setMessage("");

  //   try {
  //     const response = await APIs.post("user/loginViaOTP", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     if (response.data.status === "success") {
  //       const userData = response.data.data;

  //       // ✅ Dispatch to Redux
  //       dispatch(setUserData(userData));

  //       // ✅ Save user data in session storage
  //       sessionStorage.setItem("userData", JSON.stringify(userData));

  //       // ✅ Also save login formData (so email stays prefilled)
  //       sessionStorage.setItem("loginFormData", JSON.stringify(formData));

  //       setToastData({
  //         title: "Login",
  //         message: response.data.message,
  //         type: "success",
  //         id: Date.now(),
  //       });

  //       setTimeout(() => navigate("/OtpModel"), 1000);
  //     } else {
  //       setMessage(response.data.message || "Login failed.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setMessage(
  //       error.response?.data?.message || "Login failed. Please try again."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    // <div
    //   className="modal fade commen-popup"
    //   id="LoginModalToggle"
    //   aria-hidden="true"
    //   aria-labelledby="LoginModalToggleLabel"
    //   tabIndex="-1"
    // >
    //   <div className="modal-dialog modal-lg modal-dialog-centered">
    //     <div className="modal-content">
    //       <div className="modal-body">
    //         <div className="row">
    //           <div className="col-lg-6">
    //             <button
    //               type="button"
    //               className="btn-close"
    //               data-bs-dismiss="modal"
    //               aria-label="Close"
    //             ></button>
    //             <h5 className="modal-title" id="LoginModalToggleLabel">
    //               Login
    //             </h5>
    //             <p>
    //               Welcome Back! Let's get started. Please sign in to access all
    //               the amazing services
    //             </p>

    //             <form
    //               className="Login-form"
    //               onSubmit={handleSubmit}
    //               noValidate
    //             >
    //               <div className="row">
    //                 <div className="col-sm-12 mb-2">
    //                   <input
    //                     type="email"
    //                     className="form-control"
    //                     placeholder="Email *"
    //                     name="email"
    //                     value={formData.email}
    //                     onChange={handleChange}
    //                   />
    //                   {errors.email && (
    //                     <small className="text-danger">{errors.email}</small>
    //                   )}
    //                 </div>

    //                 <div className="col-sm-12 mb-2">
    //                   <input
    //                     type="password"
    //                     className="form-control"
    //                     placeholder="Password *"
    //                     name="password"
    //                     value={formData.password}
    //                     onChange={handleChange}
    //                   />
    //                   {errors.password && (
    //                     <small className="text-danger">{errors.password}</small>
    //                   )}
    //                 </div>

    //                 <div className="col-md-12 mb-3">
    //                   <button
    //                     type="submit"
    //                     className="eagle-btn text-center w-100"
    //                     disabled={loading}
    //                   >
    //                     <span className="eagle-button-text">
    //                       {loading ? "Logging in..." : "Login"}
    //                     </span>
    //                     <span className="eagle-button-icon-wrapper">
    //                       <span className="eagle-button-icon">
    //                         <i className="eagle-base-icon-black-arrow-1"></i>
    //                       </span>
    //                     </span>
    //                   </button>
    //                 </div>

    //                 <div className="col-md-12 mb-3">
    //                   <a
    //                     className="loginwith-google text-center eagle-btn w-100"
    //                     href="#"
    //                   >
    //                     <img
    //                       src="images/google.svg"
    //                       className="img-fluid"
    //                       alt="google"
    //                     />
    //                     <span className="eagle-button-text">Login with Google</span>
    //                   </a>
    //                 </div>

    //                 <div className="col-md-12 col-lg-12">
    //                   Don't have an account?{" "}
    //                   <a
    //                     href="javascript:void(0)"
    //                     data-bs-target="#signupModalToggle"
    //                     data-bs-toggle="modal"
    //                     data-bs-dismiss="modal"
    //                   >
    //                     Sign Up Now!
    //                   </a>
    //                 </div>

    //                 <div className="col-md-12 col-lg-12 message-status text-danger">
    //                   {message && <p>{message}</p>}
    //                 </div>
    //               </div>
    //             </form>
    //           </div>

    //           <div className="col-lg-6">
    //             <img
    //               src="images/banner-slider-img/1.jpg"
    //               className="img-fluid"
    //               alt="banner"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <></>
  );
};

export default LoginModal;
